import { Component, Input, OnInit } from '@angular/core';
import { StatusService } from '../../../services/status.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatChipInputEvent } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Status } from '../../../interfaces/status';
import { ToastsManager } from 'ng2-toastr';
import { LoggerService } from '../../../services/logger.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-status-edit',
  templateUrl: './status-edit.component.html',
  styleUrls: ['./status-edit.component.scss']
})
export class StatusEditComponent implements OnInit {
  @Input()
  public status: Status;

  public rolesAllowedToViewItemsAtThisStatus = [];
  public rolesAllowedToEditItemsAtThisStatus = [];
  public itemAttributesVisibleAtThisStatus = [];
  public itemAttributesEditableAtThisStatus = [];
  public tasks = <string[]>[];
  public metadata = {};
  public statusForm: FormGroup;
  private statusId: string;
  public isStatusLoading = false;
  public isSubmitting = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastsManager,
    private service: StatusService,
    public translate: TranslateService
  ) {
    this.statusForm = new FormGroup({
      orderNumber: new FormControl('', [Validators.required]),
      statusName: new FormControl('', [Validators.required]),
      statusCode: new FormControl('', [Validators.required]),
      statusTask: new FormControl('', []),
      itemAtThisStatusIsAvailable: new FormControl(false),
      isCodeRequired: new FormControl(false)
    });
  }

  ngOnInit() {
    this.statusId = this.route.snapshot.paramMap.get('id');
    if (this.statusId) {
      this.isStatusLoading = true;

      this.service.getStatusById(this.statusId).subscribe(status => {
        this.statusForm.patchValue({
          orderNumber: status.orderNumber,
          statusName: status.statusName,
          statusCode: status.statusCode,
          isCodeRequired: status.isCodeRequired,
          itemAtThisStatusIsAvailable: status.itemAtThisStatusIsAvailable
        });
        this.rolesAllowedToViewItemsAtThisStatus = status.rolesAllowedToViewItemsAtThisStatus;
        this.rolesAllowedToEditItemsAtThisStatus = status.rolesAllowedToEditItemsAtThisStatus;
        this.itemAttributesVisibleAtThisStatus = status.itemAttributesVisibleAtThisStatus;
        this.itemAttributesEditableAtThisStatus = status.itemAttributesEditableAtThisStatus;
        this.metadata = status.metadata;
        this.tasks = status.tasks;
        this.isStatusLoading = false;
      });
    } else {
      this.rolesAllowedToViewItemsAtThisStatus = [];
      this.rolesAllowedToEditItemsAtThisStatus = [];
      this.itemAttributesVisibleAtThisStatus = [];
      this.itemAttributesEditableAtThisStatus = [];
      this.metadata = {};
      this.tasks = [];
    }
  }

  addTag(event: MatChipInputEvent, array): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      array.push(value.trim());
    }

    if (input) {
      input.value = '';
    }
  }

  removeTag(tag: any, array): void {
    const index = array.indexOf(tag);

    if (index >= 0) {
      array.splice(index, 1);
    }
  }

  saveStatus(statusForm: FormGroup) {
    const status: Status = {
      orderNumber: statusForm.value.orderNumber,
      statusName: statusForm.value.statusName,
      statusCode: statusForm.value.statusCode,
      metadata: this.metadata,
      rolesAllowedToViewItemsAtThisStatus: this.rolesAllowedToViewItemsAtThisStatus,
      rolesAllowedToEditItemsAtThisStatus: this.rolesAllowedToEditItemsAtThisStatus,
      itemAttributesVisibleAtThisStatus: this.itemAttributesVisibleAtThisStatus,
      itemAttributesEditableAtThisStatus: this.itemAttributesEditableAtThisStatus,
      isCodeRequired: statusForm.value.isCodeRequired,
      itemAtThisStatusIsAvailable: statusForm.value.itemAtThisStatusIsAvailable,
      tasks: this.tasks
    };

    this.isSubmitting = true;

    if (this.statusId) {
      this.service
        .updateStatus(this.statusId, status)
        .pipe(finalize(() => (this.isSubmitting = false)))
        .subscribe(
          savedStatus => {
            this.status = savedStatus;
            this.router.navigate(['statuses']);
          },
          error => {
            LoggerService.log('StatusEditComponent::saveStatus', error);
            this.toastr.error(this.translate.instant('STATUS_EDIT.COMPONENT.UPDATE_ERROR'));
          }
        );
    } else {
      this.service
        .createStatus(status)
        .pipe(finalize(() => (this.isSubmitting = false)))
        .subscribe(
          savedStatus => {
            this.status = savedStatus;
            this.router.navigate(['statuses']);
          },
          error => {
            LoggerService.log('StatusEditComponent::saveStatus', error);
            this.toastr.error(this.translate.instant('STATUS_EDIT.COMPONENT.CREATE_ERROR'));
          }
        );
    }
  }

  addNewTask(statusForm) {
    const taskContent = statusForm.value.statusTask;
    if (taskContent.trim()) {
      this.tasks.push(taskContent);
    }
    this.statusForm.patchValue({
      statusTask: ''
    });
  }

  deleteTask(event: Event, index): void {
    if (index >= 0) {
      this.tasks.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/lifecycle/status-edit/status-edit.component.ts